<template>
  <q-dialog v-model="shown">
    <q-card style="min-width: 400px;">
      <q-inner-loading :showing="loading" />
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Bulk Order Printing
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section class="row">
        <q-chip square>
          {{ orderCount }} Orders Selected For Printing
        </q-chip>
      </q-card-section>
      <q-card-section>
        <span class="text-h6">
          Options
        </span>
      </q-card-section>
      <q-card-section>
        <q-checkbox
          v-model="printMerchantCopy"
          label="Print Merchant Copy"
        />
        <slot name="custom-options" />
      </q-card-section>
      <q-card-actions>
        <q-btn
          color="primary"
          label="Print"
          :loading="loading"
          @click="print"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>

export default {
  name: 'PrintDialog',
  props: {
    orderCount: {
      type: Number,
      required: true
    }
  },
  emits: ['print'],
  data () {
    return {
      printMerchantCopy: false,
      shown: false,
      loading: false,
      printAll: false
    }
  },
  methods: {
    print () {
      this.loading = true
      this.$emit('print', this.printMerchantCopy)
    },
    show () {
      this.loading = false
      this.shown = true
    },
    hide () {
      this.loading = false
      this.shown = false
    }
  }
}
</script>
